import SalesPageForm from './SalesPageForm';

export default SalesPageForm;
